<div class="logo">
    <div class="image">
        <img [src]="logoUrl" style="width:95%; height: 60%; align-items: center; " />
    </div>

</div>

<!-- margin-left: 10px; margin-right: 10px; margin-top: 10px; margin-bottom: 10px; -->

